import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';

import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  getCancellationValuesSelector,
  getinitialShipperOrder,
  getQuote,
  getUserInfo,
  isMainLoading,
  isSubmiting,
} from 'redux/modules/shipper-order-form/selectors';

import {
  getBreakModalMode,
  isBreakModalOpened as isBreakModalOpenedSelector,
  isCancelModalOpened,
} from 'redux/modules/shipper-order-edit/selectors';

import {
  initForm,
  shipperOrderCancel,
  submitForm,
  toggleOpenModal as toggleOpenModalAction,
} from 'redux/modules/shipper-order-edit/effects';

import { StyledLoading } from 'modules/Common/form/styled';

import { Modal } from '@ontruck/orc';

import FormModalHeader from 'modules/shipper-order/FormModalHeader';

import { ShipperOrderForm, ShipperOrderFormWrapper } from 'modules/shipper-order/Form';

import BreakModal from 'modules/shipper-order/BreakModal';
import CancelModal from 'modules/shipper-order/CancelModal';

import {
  CANCELLED,
  DAY_HOLIDAY_EXTRA,
  DISCOUNT_EXTRA,
  MANAGEMENT_FEE_EXTRA,
  NEGOTIATED_EXTRA,
  PRICE_INCREMENT_EXTRA,
  RETURN_EXTRA,
  STANDSTILL_EXTRA,
  TENDER_EXTRA,
} from 'modules/shipper-order/Form/constants';
import { TenantExtras } from 'tenant/bussines';

const disabledFields = ['user', 'shipper'];

const activeExtras = TenantExtras?.activeExtras || [
  DAY_HOLIDAY_EXTRA,
  PRICE_INCREMENT_EXTRA,
  DISCOUNT_EXTRA,
  STANDSTILL_EXTRA,
  TENDER_EXTRA,
  MANAGEMENT_FEE_EXTRA,
  NEGOTIATED_EXTRA,
];

const disabledExtras = [TENDER_EXTRA, RETURN_EXTRA];

const Edition = ({
  formikProps,
  onClose,
  isBreakModalOpened,
  breakModalMode,
  toggleOpenModal,
  showOnlyQuote,
  cancellationValues,
  intl,
}) => {
  const { values = {} } = formikProps;
  const t = intl.messages.modules.shipper_order.form.edit_modal;
  const returnExtra = values.extra_prices?.find((extra) => extra.concept === RETURN_EXTRA);
  return (
    <Fragment>
      <Modal
        onClose={onClose}
        show={true}
        size="XL"
        headerComponent={
          !showOnlyQuote ? (
            <FormModalHeader
              onCancelClick={() => {
                toggleOpenModal(true);
              }}
              showCancelButton={values.status !== CANCELLED}
              {...formikProps}
            />
          ) : (
            t.viewOrder
          )
        }
      >
        <ShipperOrderForm
          onClose={onClose}
          allowShipperEdit={false}
          allowUserEdit={false}
          isEdition={true}
          submitText={t.submit}
          disabledFields={disabledFields}
          activeExtras={[...activeExtras, returnExtra ? RETURN_EXTRA : '']}
          disabledExtras={disabledExtras}
          cancellationValues={cancellationValues}
          showOnlyQuote={showOnlyQuote}
          {...formikProps}
        />
      </Modal>
      {isBreakModalOpened && <BreakModal {...formikProps} mode={breakModalMode} />}
    </Fragment>
  );
};

Edition.propTypes = {
  formikProps: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  isBreakModalOpened: PropTypes.bool,
  breakModalMode: PropTypes.string.isRequired,
  toggleOpenModal: PropTypes.func.isRequired,
};

class ShipperOrderEditModal extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { initForm, shipperOrderId } = this.props;

    initForm(shipperOrderId);
  }

  handleSubmit(shipperOrder) {
    const { submitForm } = this.props;

    submitForm(shipperOrder);
  }

  render() {
    const {
      initialShipperOrder,
      mainLoading,
      onClose,
      isCancelModalOpened,
      toggleOpenModal,
      shipperOrderCancel,
      userInfo,
      showOnlyQuote,
      cancellationValues,
      intl,
    } = this.props;
    const t = intl.messages.modules.shipper_order.form.edit_modal;
    if (mainLoading || !initialShipperOrder) {
      return (
        <Modal
          onClose={onClose}
          show={true}
          size="XL"
          headerComponent={showOnlyQuote ? t.viewOrder : t.title}
        >
          <StyledLoading />
        </Modal>
      );
    }

    return (
      <Fragment>
        <ShipperOrderFormWrapper
          initialShipperOrder={initialShipperOrder}
          onSubmit={this.handleSubmit}
        >
          {(formikProps) => (
            <Edition
              formikProps={formikProps}
              cancellationValues={cancellationValues}
              int={intl}
              {...this.props}
            />
          )}
        </ShipperOrderFormWrapper>

        {isCancelModalOpened && (
          <CancelModal
            show={true}
            shipperOrder={initialShipperOrder}
            onClose={() => toggleOpenModal(false)}
            currency={userInfo.currency}
            cancellationValues={cancellationValues}
            onSubmit={shipperOrderCancel}
            showCarrierSection={((initialShipperOrder || {}).journeys || []).length}
          />
        )}
      </Fragment>
    );
  }
}

ShipperOrderEditModal.propTypes = {
  initialShipperOrder: PropTypes.object,
  mainLoading: PropTypes.bool.isRequired,
  initForm: PropTypes.func.isRequired,
  shipperOrderId: PropTypes.number,
  submitForm: PropTypes.func,
  onClose: PropTypes.func,
  isCancelModalOpened: PropTypes.bool,
  toggleOpenModal: PropTypes.func,
  userInfo: PropTypes.object,
  shipperOrderCancel: PropTypes.func,
};

const actionCreators = {
  initForm,
  submitForm,
  toggleOpenModal: toggleOpenModalAction,
  shipperOrderCancel,
};

export default connect(
  (state) => ({
    mainLoading: isMainLoading(state),
    initialShipperOrder: getinitialShipperOrder(state),
    isBreakModalOpened: isBreakModalOpenedSelector(state),
    isCancelModalOpened: isCancelModalOpened(state),
    breakModalMode: getBreakModalMode(state),
    userInfo: getUserInfo(state),
    quote: getQuote(state),
    submiting: isSubmiting(state),
    cancellationValues: getCancellationValuesSelector(state),
  }),
  actionCreators
)(injectIntl(ShipperOrderEditModal));
